export enum NavType {
  PowerMap,
  LightingMap,
  IndustrialGasMap,
  WaterMap,
  EnergyCockpit,
  OperationOverview,
  EnvironmentalMonitor,
}

export const NavTypeDisplay = {
  [NavType.PowerMap]: '电力监控',
  [NavType.LightingMap]: '照明控制',
  [NavType.WaterMap]: '水务监控',
  [NavType.EnergyCockpit]: '能源概览',
  [NavType.IndustrialGasMap]: '用气监控',
  [NavType.OperationOverview]: '运维总览',
  [NavType.EnvironmentalMonitor]: '环保监控',
};
export const NavTypeTitleDisplay = {
  [NavType.PowerMap]: 'CSSC|SWS - 电力保障监控中心',
  [NavType.LightingMap]: 'CSSC|SWS - 照明保障监控中心',
  [NavType.WaterMap]: 'CSSC|SWS - 水务保障监控中心',
  [NavType.IndustrialGasMap]: 'CSSC|SWS - 用气保障监控中心',
  [NavType.EnergyCockpit]: 'CSSC|SWS - 能碳管理中心',
  [NavType.OperationOverview]: 'CSSC|SWS - 运维总览中心',
  [NavType.EnvironmentalMonitor]: 'CSSC|SWS - 环保监测中心',
};

/** 高杆灯状态 */
export enum HighMastLightStatus {
  /** 分闸 */
  Open = 0,
  /** 合闸 */
  Closed = 1,
  /** 离线 */
  Offline = 2,
}

export const HighMastLightStatusDisplay = {
  [HighMastLightStatus.Open]: 'off',
  [HighMastLightStatus.Closed]: 'on',
  [HighMastLightStatus.Offline]: 'offline',
};
